import { loadLanguage } from "../Components/Common/language";

export const STATE_CURRENCY = "shop-currency";
export const STATE_CULTURE = "shop-culture";
export const STATE_SALE_ID = "checkout-saleId";
export const STATE_POS_ID = "checkout-posId";

export const setCookie = (key, value) => {
  return {
    type: "@EE/SET_COOKIE",
    key,
    value,
  };
};

export const expireCookie = (key) => {
  return {
    type: "@EE/EXPIRE_COOKIE",
    key,
  };
};

export const setCurrency = (currency) => {
  return setCookie(STATE_CURRENCY, currency);
};

export const setCulture = (culture, config) => (dispatch) => {
  loadLanguage(culture, config, dispatch, config);
  dispatch(setCookie(STATE_CULTURE, culture));
};

export const setSaleId = (saleId) => {
  return setCookie(STATE_SALE_ID, saleId);
};

export const setPosId = (posId) => {
  return setCookie(STATE_POS_ID, posId);
};

export const clearSaleId = () => {
  return expireCookie(STATE_SALE_ID);
};
